// @core/api/endpoints/payment/delete_payment_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/payment';

/**
 * Delete payment type
 * Deactivates a payment type. Existing payments of this type are not affected.
 */
export async function DeletePaymentType(
  type_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payment-types/:type_id`;
  requestPath = requestPath.replace(':type_id', encodeURIComponent(type_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
